import authenticationFilter from './authentication-filter.ts';
import type { AsyncLocalStorage } from 'node:async_hooks';
import { x509Converter } from './x509-converter.ts';
import { subjectX500PrincipalExtractor, type X509PrincipalExtractor } from './preauth/x509.ts';
import type { AuthenticationConverter, AuthenticationManager } from './types.ts';
import { preAuthenticatedAuthenticationManager } from './users.ts';
import type { WebFilter } from '../../web/server/types.ts';


export default function x509(opts: {
    readonly storage: AsyncLocalStorage< {} >,
    readonly manager?: AuthenticationManager,
    readonly extractor?: X509PrincipalExtractor,
    readonly converter?: AuthenticationConverter,
    getService: <T>(type: string) => T
}): WebFilter {
    const manager = opts.manager ?? preAuthenticatedAuthenticationManager({
        userDetailsService: opts.getService('UserDetailsService')
    });
    const principalExtractor = opts.extractor ?? subjectX500PrincipalExtractor();
    const converter = opts.converter ?? x509Converter({ principalExtractor })
    return authenticationFilter({
        storage: opts.storage,
        manager,
        converter
    })
}
